import { getAnswers, setAnswers } from '@/helpers/LocalStorageService';
import FormService from '@/services/FormService';
import { IAnswer, IComponent } from '@/services/FormStructure';
import Conditional from '@/app/Survey/model/conditionals/Conditional';
import { isQuestionComponent } from '@/app/Survey/model/Form';

export interface IDeletePartialAnswersParams {
    transactionReference: number | string;
    formId: number;
    questionIds: number[];
    answersStorage: IAnswer[][];
    allComponents: IComponent[];
    shouldShowItsSelf: (conditionals: Conditional[]) => boolean;
}

export default class DeletePartialAnswersService {
    constructor(private formService: FormService) {}

    async deleteUnwantedPartialAnswers(params: IDeletePartialAnswersParams): Promise<void> {
        try {
            const { transactionReference, formId, questionIds: initialQuestionIds, answersStorage, allComponents, shouldShowItsSelf } = params;

            if (!answersStorage) {
                return;
            }

            const questionIds: number[] = initialQuestionIds ?? [];

            answersStorage.forEach((answerList: IAnswer[]) => {
                const answeredQuestion = allComponents.find(component => isQuestionComponent(component) && component.id === answerList[0]?.formQuestionId);

                if (answeredQuestion && answerList.length && !shouldShowItsSelf(answeredQuestion.conditionals)) {
                    answerList.forEach((answer: IAnswer) => {
                        answer.answer = null;
                        if (answeredQuestion?.type === 'SimpleTextComponent') {
                            answer.text = null;
                        }
                    });
                    answeredQuestion.answer = answeredQuestion.settings?.selectionStrategy != 'multiple' ? {} : [];
                    questionIds.push(+answeredQuestion.id);
                }
            });

            if (questionIds.length > 0) {
                const unansweredItems = this.getUnansweredItems(answersStorage, allComponents);
                setAnswers(transactionReference, unansweredItems, formId);

                await this.formService.deletePartialAnswers({
                    formId: +formId,
                    transactionId: +transactionReference,
                    questionIds,
                });
            }
        } catch (error) {
            console.error('Error to delete partial answers', error);
            throw error;
        }
    }

    private getUnansweredItems(answersStorage: IAnswer[][], allComponents: IComponent[]): IAnswer[][] {
        return answersStorage.filter((item: IAnswer[]) =>
            item.every((answer: IAnswer): boolean => {
                const question = allComponents.find(component => isQuestionComponent(component) && component.id === answer.formQuestionId);
                if (question?.type === 'SimpleTextComponent') return answer.text != null;
                return answer.answer != null;
            }),
        );
    }
}
